<template>
  <div class="topbarcontain">
      <img src="@/assets/topbar/logo.png" class="log"/>
      <div class="choose">
          <ul>
              <li>
                  <span v-click-outside="closeShow" @click="toggleShow('showmain')">{{getLan('9fb95ca9-bbcd-41c8-ac47-4e4e6216759a')}}<img src="@/assets/topbar/arrowdown.png"/></span>
                  <div class="pop" v-show="showmain">
                    <div @click="jumpto('jumpintro')" class="item">
                        {{getLan('d38f22d1-7221-403a-abe9-dde7449ccd51')}}
                    </div>
                    <div @click="jumpto('jumppro')" class="item">
                        {{getLan('405a77bc-fc7e-4ca9-a67d-806cd010c329')}}
                    </div>
                    <div @click="jumpto('jumpnews')" class="item">
                        {{getLan('c5462256-76f1-4ce7-854c-98e9e37ca1e9')}}
                    </div>
                    <div @click="jumpto('jumpteam')" class="item">
                        {{getLan('43295f33-6e60-4e89-99ee-f298da9f294b')}}
                    </div>
                  </div>
              </li>
              <li>
                  <span class="add-us" @click="toggleShow('showAddus')" v-click-outside="closeShow">{{getLan('dbbb269b-7499-44b6-8987-676fdeec311b')}}</span>
                  <div class="pop pop-2" v-show="showAddus">
                      <div class="item" @click="addUs">
                          {{getLan('9dc6fbbc-17c2-43cf-b712-f33c3eec980b')}}
                      </div>
                      <div class="item" @click="addUs2">
                          {{getLan('43420b29-f472-43f4-8bf0-a70fd8254351')}}
                      </div>
                  </div>
              </li>
              <li>
                  <span @click="toggleShow('showLanguage')" v-click-outside="closeShow">{{getLan('dcf4362f-401b-4466-b250-8b3fd8e5de18')}}<img src="@/assets/topbar/arrowdown.png"/></span>
                  <div class="pop" v-show="showLanguage">
                      <div class="item" @click="changeLanguage('zh-CN')">
                          {{getLan('a06017f6-0559-4271-95aa-8b3c93601721')}}
                      </div>
                      <div class="item" @click="changeLanguage('zh-TW')">
                          {{getLan('04b970bd-af9a-4be5-8171-d7d106a50bcb')}}
                      </div>
                      <div class="item" @click="changeLanguage('en')">
                          English
                      </div>
                  </div>
              </li>
          </ul>
      </div>
    <a v-show="false" href="./#/allGame" id="goGame" target="_blank"/>
    <a href="./#/product" v-show="false" id="goPro" target="_blank"/>
    <a v-show="false" id="addus" href="https://lexinshengwen-dingtalk.mokahr.com/social-recruitment/lexinshengwen/100276" target="_blank"></a>
    <a v-show="false" id="addus2" href="https://lexinshengwen-dingtalk.mokahr.com/campus-recruitment/lexinshengwen/92298" target="_blank"></a>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
    data() {
        return {
            showmain: false,
            showproduct: false,
            showLanguage: false,
            showAddus: false,
        }
    },
    methods: {
        toggleShow(type) {
            this[type] = !this[type]
            if (this[type]) {
                if (type === 'showmain') {
                    this.showproduct = false
                    this.showLanguage = false
                    this.showAddus = false
                } else if (type === 'showproduct') {
                    this.showmain = false
                    this.showLanguage = false
                    this.showAddus = false
                } else if (type === 'showAddus') {
                    this.showmain = false
                    this.showproduct = false
                    this.showLanguage = false
                } else {
                    this.showmain = false
                    this.showproduct = false
                    this.showAddus = false
                }
            }
        },
        closeShow(type) {
            // this[type] = false
            this.showmain = false
            this.showproduct = false
            this.showLanguage = false
        },
        changeLanguage(type) {
            this.bus.nowLan = type
            this.closeShow()
        },
        jumpto(id) {
            this.closeShow()
            if (document.querySelector(`#${id}`) === null) {
                location.href = '/#/?lan='+this.bus.nowLan
                return
            }
            document.querySelector(`#${id}`).scrollIntoView()
        },
        goPro() {
            document.querySelector('#goPro').click()
        },
        goGame() {
            document.querySelector('#goGame').click()
        },
        addUs() {
            document.querySelector('#addus').click()
        },
        addUs2() {
            document.querySelector('#addus2').click()
        }
    },
    mounted() {
        this.popupItem = this.$el
    },
    directives: {
        ClickOutside,
    },
}
</script>

<style scoped>
.topbarcontain {
    box-sizing: border-box;
    height: 6rem;
    padding: 2rem 0rem 2rem 22rem;
    box-shadow:0rem 0rem 1rem 0rem rgba(46,46,46,0.24);
    user-select:none;
    width: 100rem;
}
.topbarcontain .log {
    width: 11rem;
    height: 2rem;
}
.topbarcontain .choose {
    display: inline-block;
    margin-left: 23rem;
    color: rgba(102,102,102,1);
    font-size: 0.73rem;
    vertical-align: top;
    /* line-height: 2rem; */
    height: 2rem;
}
.topbarcontain .choose ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.topbarcontain .choose img {
    width: 0.58rem;
    height: 0.31rem;
    vertical-align: 0.1rem;
    margin-left: 0.36rem;
}
.topbarcontain .choose li  {
    cursor: pointer;
    display: inline-block;
    padding-right: 2rem;
    position: relative;
}
.topbarcontain .choose span {
    line-height: 2rem;
}
.add-us {
    background: #FD9A27;
    color: #fff;
    padding: 0.29rem 0.93rem 0.36rem 0.95rem;
    border-radius: 1rem;
}
.pop {
    position: absolute;
    border-radius: 10%;
    box-shadow:0rem 0rem 1rem 0rem rgba(46,46,46,0.18);
    background: #fff;
    right: 1rem;
    padding-bottom: 0.5rem;
    z-index: 3000;
}
.pop-2{
    right: 2rem;
}

.pop .item {
    font-size: 0.73rem;
    line-height: 0.95rem;
    color: #666;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    white-space: nowrap;
}

.pop .item:hover {
    background: #EFEFEF;
}
</style>


// WEBPACK FOOTER //
// src/components/TopBar.vue